import {
	Box,
	Button,
	Divider,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
} from "@mui/material";
import TvIcon from "@mui/icons-material/Tv";
import React from "react";
import { sizes } from "../analyzeUtils";
import { useDispatch, useSelector } from "react-redux";
import { getDurations, getFourPLData, setState } from "../analyzeSlice";
import { useState, useEffect } from "react";
import Alert from "../../../components/ui/Alert";

const selectWidth = sizes.w200;
const selectHeight = sizes.h35;

export default function Form() {
	const [validate, setValidate] = useState({
		countryValidated:false,
		durationValidated:false
	});
	const [alert, setAlert] = useState({
		alertSeverity:"",
		alertDisplay:false,
		alertMessage:""
	})
	const dispatch = useDispatch();
	const state = useSelector((store) => store.analyze);
	const loginState = useSelector((store) => store.login);

	const {
		countries,
		selectedCountry,
		duration,
		durations,
		selectedCountryID,
		isDisPlayExport,
	} = state;

	const {
		globalSelectedCountryName,
		globalSelectedCountryID,
	} = loginState

	useEffect(() => {
		dispatch(setState("selectedCountry", ""));
		dispatch(setState("duration", ""));
		dispatch(setState("clearAnalyze3PL", false));
	},[])

	useEffect(() => {
		dispatch(getDurations([]));
		if (durations?.length <= 0) {
			dispatch(getDurations());
		}
	}, []);

	function setCountry(event) {
		const name = event.target.value;
		console.log("Country Name", name);
		// if(name=="France"){
		// 	dispatch(setState("isDisPlayExport",false));
		// }
		// else{
		// 	dispatch(setState("isDisPlayExport",true));
		// }
		dispatch(setState("isDisPlayExport",true));
		
		let countryID=0;
		if(name!=="All"){
		 countryID = countries?.find(
			(country) => country.countryName === name
		).countryID;
		}
		if(name){
			setValidate({
				...validate, countryValidated:true
			})
		}
		dispatch(setState("selectedCountry", name));
		dispatch(setState("selectedCountryID", countryID));

		dispatch(setState("clearAnalyze3PL", false));
	}

	useEffect(() => {
		if(globalSelectedCountryID !== null){
		dispatch(setState("selectedCountryID", globalSelectedCountryID));
		}
	},[globalSelectedCountryID])

	useEffect(() => {
		if(globalSelectedCountryName !== null){
		dispatch(setState("selectedCountry", globalSelectedCountryName));
		}
	},[globalSelectedCountryName])

	function setDuration(event) {
		const d = event.target.value;
		if(d){
			setValidate({
				...validate, durationValidated:true
			})
		}
		dispatch(setState("duration", d));
	}

	const displayAlert = (severityType) => {
		setAlert({
			"alertSeverity": "warning",
			"alertDisplay": true,
			"alertMessage": `Please select the ${severityType}`});
	}

	useEffect(() => {
		//Check if any of the dropdown are false and then set alertDisplay to false
		const isAnyKeyValueFalse = o => !!Object.keys(o).find(k => !o[k]);

		if(isAnyKeyValueFalse(validate)){
			setAlert({...Alert, alertDisplay:false});
		}
	},[validate])

	function handleDisplay() {
		const obj = {
			countryID: selectedCountryID,
			duration,
		};

		//Alert if any of the dropdowns are not validated

		if(!validate.countryValidated){
			displayAlert("Country")
		}
		else if(!validate.durationValidated){
			displayAlert("Duration")
		}
		else{
			dispatch(setState("clearAnalyze3PL", true));
			dispatch(getFourPLData(obj));
		}	
	}

	return (
		<Box sx={{ mt: 3 }}>
			<Grid container columns={10} spacing={2} justifyContent="flex-start">
				<Grid item sm={4} md={2}>
					<FormControl>
						<InputLabel>Country</InputLabel>
						<Select
							value={selectedCountry}
							label="Country"
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setCountry}
						>
							<MenuItem value={"All"}>{"All"}</MenuItem>
							{countries?.map((country, index) => {
								return (
									<MenuItem key={index} value={country.countryName}>
										{country.countryName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item sm={4} md={1.5}>
					<FormControl>
						<InputLabel>Period</InputLabel>
						<Select
							value={duration}
							label="Period"
							sx={{
								height: selectHeight,
								width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={setDuration}
						>
							<MenuItem value={"All"}>{"All"}</MenuItem>
							{durations?.map((duration, index) => {
								return (
									<MenuItem key={index} value={duration.value}>
										{duration.value}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>

				<Grid item sm={1} md={.8}>
					<Button
						startIcon={<TvIcon />}
						sx={{
							bgcolor: "darkred.light",
							color: "white.main",
							textTransform: "none",
							fontWeight: "bold",
							"&:hover": {
								bgcolor: "darkred.main",
							},
						}}
						onClick={handleDisplay}
					>
						Display
					</Button>
				</Grid>
			</Grid>
			{alert.alertDisplay && <Alert message={alert.alertMessage} severity={alert.alertSeverity} />}
		</Box>
	);
}
